import React from "react";
import OmniFormGroup from "../Shared/OmniFormGroup/OmniFormGroup";

const ProfileField = (props) => {
  return (
    <OmniFormGroup
      Id={props.name}
      Name={props.name}
      LabelName={props.label}
      Type={props.type}
      Placeholder={props.label}
      Value={props.defaultValue}
      onChange={props.onChange}
      Disabled={!props.EditMode}
      disabledBuTNoLockIcon={true}
      Required={props.required}
    >
      {props.type === "select" &&
        props.values &&
        props.values.length > 0 &&
        props.values.map((opt) => (
          <option value={opt.Value} key={opt.Value}>
            {opt.Text}
          </option>
        ))}
    </OmniFormGroup>
  );
};

export default ProfileField;
